// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import * as z from 'zod';
import { hubspotConfigurationResponseSchema } from '@/account/api/types';
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { serializeDateForAPI } from '@/utilities/date-time';
import { DateTime } from 'luxon';

/** Type representing the validated response from updating an organization */
type UpdateOrganizationResponse = z.infer<
  typeof hubspotConfigurationResponseSchema
>;

export interface UpdateHubspotPipelineItem {
  pipelineId: string;
  stageId: string;
  isEnabled: boolean;
  startDate: DateTime | null;
  shouldRemovePipeline: boolean;
}

export async function updateHubspotPipelines(
  parameters: UpdateHubspotPipelineItem[]
): Promise<UpdateOrganizationResponse> {
  const url = `/v1/crm/hubspot/pipeline`;
  const response = await api.post(
    url,
    parameters.map((parameter) => ({
      ...parameter,
      startDate: serializeDateForAPI(parameter.startDate),
    }))
  );

  return parseResponse(hubspotConfigurationResponseSchema, response.data, {
    schemaName: 'UpdateHubspotPipelines',
    endpoint: url,
  });
}

export async function syncHubspotPipelineConfig(): Promise<UpdateOrganizationResponse> {
  const url = `/v1/crm/hubspot/pipeline/sync`;
  const response = await api.post(url);

  return parseResponse(hubspotConfigurationResponseSchema, response.data, {
    schemaName: 'SyncHubspotPipelineConfig',
    endpoint: url,
  });
}

export const hubspotPipelineQueryKey = ['hubspot', 'pipeline'];
